import { useEffect, useState } from "react";
import { api } from "./api";
import type { Profile } from "@/types";

export function useProfile() {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = () => {
    setLoading(true);
    api.profile
      .get()
      .then(setProfile)
      .finally(() => setLoading(false));
  };

  useEffect(reload, []);

  return { profile, loading, reload, setProfile };
}
